import React from 'react'
import type { TreeLines } from './subtaskTreeLayout'

/**
 * Die **Verbindungslinien** einer Zeile im Baum (#211, Prototyp-Variante E, wie Linear): Bogen vom
 * Stamm des Eltern-Teils an den eigenen Haken, der Stamm darunter, solange Geschwister folgen,
 * durchlaufende Striche weiter links und der Stamm unter dem eigenen Haken, wenn Kinder folgen.
 * Liegt in der Zeile, damit die Linien beim Umsortieren mit ihr wandern. Nur Bild, `aria-hidden`.
 *
 * Innenteil von `SubtaskRow` und `OpenRow`; zu sehen in den Stories von `SubtaskList`.
 *
 * @example
 * <SubtaskTreeLines lines={{ level: 1, elbow: true, continues: true, rails: [], stem: false }} />
 */
export const SubtaskTreeLines: React.FC<{ lines?: TreeLines }> = ({ lines }) => {
  if (!lines) return null
  return (
    <>
      {lines.rails.map(rail => (
        <span key={rail} className={`subtask-tree__line subtask-tree__line--rail subtask-tree__line--back-${lines.level - rail}`} aria-hidden />
      ))}
      {lines.elbow && <span className="subtask-tree__line subtask-tree__line--elbow" aria-hidden />}
      {lines.continues && <span className="subtask-tree__line subtask-tree__line--lower" aria-hidden />}
      {lines.stem && <span className="subtask-tree__line subtask-tree__line--stem" aria-hidden />}
    </>
  )
}

/** Klassen einer Zeile im Baum: Einrückung je Ebene, und Bezugsrahmen, wenn sie Linien trägt. */
export function treeRowClasses(lines: TreeLines | undefined): string[] {
  if (!lines) return []
  const drawn = lines.elbow || lines.stem || lines.rails.length > 0
  return [lines.level > 0 ? `subtask-row--l${lines.level}` : '', drawn ? 'subtask-row--tree' : ''].filter(Boolean)
}
